<div
    class="status"
    [ngClass]="mode() === 'complex' ? ['complex', type()] : {}"
    [matTooltip]="tooltip()"
>
    <mat-icon
        class="weight-icon"
        [ngClass]="mode() === 'complex' ? ['complex', type()] : type()"
        [class]="type() === 'default' ? 'material-icons-outlined ' : mode()"
    > circle </mat-icon>
    <span [ngClass]="mode() === 'complex' ? ['complex', type()] : {}" [class.no-wrap]="noWrap()">
        <ng-content></ng-content>
    </span>
</div>
